import Icon from "../../Icon/Icon";
import SVGIcon from "../../Icon/SVGIcon";
import Tooltip from "../../wrappers/Tooltip/Tooltip";
import { CSSProperties } from "react";
import { Color } from "../../../../utils/sys/Color";

import { useMemo } from "react";

export type ButtonColor = "neutral" | "active" | "warning" | "cancel";

export default function Button(props: {
    color?: ButtonColor;
    label?: string;
    icon?:
        | string
        | React.ReactElement<typeof Icon>
        | React.ReactElement<typeof SVGIcon>
        | null;
    iconSize?: number;
    style?: CSSProperties;
    tooltip?: string;
    onClick?: (event: React.MouseEvent) => void;
}): React.ReactElement {
    const { color, label, icon, iconSize, style, tooltip, onClick } = props;

    const buttonIcon = useMemo((): React.ReactElement | null => {
        if (icon == null) {
            return null;
        }

        if (typeof icon === "string") {
            return (
                <img
                    src={icon}
                    width={iconSize ?? 16}
                    height={iconSize ?? 16}
                />
            );
        }

        return icon;
    }, [icon, iconSize]);

    const buttonColor = useMemo((): Color | undefined => {
        if (color == null) {
            return undefined;
        }

        switch (color) {
            case "neutral":
                return undefined;
            case "active":
                return "#ADD8E6";
            case "warning":
                return "#FFFFE0";
            case "cancel":
                return "#FFCCCB";
        }
    }, [color]);

    const buttonStyle = useMemo((): CSSProperties => {
        return {
            ...style,
            height: style?.height ?? 30,
            margin: style?.margin ?? 2,
            backgroundColor: buttonColor,
        };
    }, [buttonColor]);

    return (
        <>
            {tooltip == null ? (
                <button style={buttonStyle} onClick={onClick}>
                    {buttonIcon}
                    {buttonIcon != null && label != null ? (
                        <div style={{ width: 8 }} />
                    ) : null}
                    {label}
                </button>
            ) : (
                <Tooltip delay={1000} tooltipContent={tooltip}>
                    <button style={buttonStyle} onClick={onClick}>
                        {buttonIcon}
                        {buttonIcon != null && label != null ? (
                            <div style={{ width: 8 }} />
                        ) : null}
                        {label}
                    </button>
                </Tooltip>
            )}
        </>
    );
}
